export default __webpack_public_path__ + "static/media/expPink.ac1de145.svg";